/**
 * Situação de MTR/CDF das coletas, composta no front.
 *
 * A listagem vem do musa-agreements com `has_mtr`/`has_cdf` nulos (ele não enxerga o
 * mtr-manager); o portal pergunta ao mtr-manager pelos ids da página e preenche. Falha nessa
 * consulta degrada o campo (continua nulo = desconhecido), nunca derruba a lista.
 */

import { fetchManifestsByCollectIds, type CollectDocumentStatus } from '@/integrations/mtrManager/client';

export type DocumentFlags = Pick<CollectDocumentStatus, 'has_mtr' | 'has_cdf'>;

export async function fetchDocumentFlags(collectIds: string[]): Promise<Map<string, DocumentFlags>> {
  if (!collectIds.length) return new Map();
  try {
    const rows = await fetchManifestsByCollectIds(collectIds);
    return new Map(rows.map((row) => [row.collect_id, { has_mtr: row.has_mtr, has_cdf: row.has_cdf }]));
  } catch (error) {
    console.warn('[collectDocumentFlags] mtr-manager indisponível; MTR/CDF ficam como desconhecidos', error);
    return new Map();
  }
}

/** Aplica as flags nos itens que têm resposta; os demais ficam como vieram (nulo). */
export function attachDocumentFlags<T extends { collect_id: string; has_mtr: boolean | null; has_cdf: boolean | null }>(
  items: T[],
  flags: Map<string, DocumentFlags>,
): T[] {
  if (!flags.size) return items;
  return items.map((item) => {
    const found = flags.get(item.collect_id);
    return found ? { ...item, has_mtr: found.has_mtr, has_cdf: found.has_cdf } : item;
  });
}
